import React from "react";
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router";
import "./style.scss";
import { observer } from "mobx-react";
import menuStore from "../../stores/menu";

const FooterForHalfAndHalf = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        if (menuStore.selectedHalfAndHalfStep === 0) {
            navigate("/menu");
            return;
        }

        menuStore.selectedHalfAndHalfStep = menuStore.selectedHalfAndHalfStep - 1;
        menuStore.selectedHalfAndHalfItems[menuStore.selectedHalfAndHalfStep] = null;
    }

    const goNext = () => {
        if (menuStore.selectedHalfAndHalfStep === 0 && menuStore.selectedHalfAndHalfItems.filter(x => !!x).length === 2) {
            menuStore.selectedHalfAndHalfStep = 2;
            navigate("/menu/halfAndHalf/info");
            return;
        }

        if (menuStore.selectedHalfAndHalfItems[menuStore.selectedHalfAndHalfStep])
            menuStore.selectedHalfAndHalfStep = menuStore.selectedHalfAndHalfStep + 1;
    }

    return <>
        <div className="FooterSpace" />
        <div className="FooterForHalfAndHalf">
            <div className="buttons">
                <div className="button back" onClick={goBack}>{t("back")}</div>
                <div className="button dark" onClick={goNext}>{t("next")}</div>
            </div>
        </div>
    </>
}

export default observer(FooterForHalfAndHalf);
